
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useField, useIsFieldTouched } from 'vee-validate';

import VInputText from '@/components/VInputText/VInputText.vue';
import VInputSwitch from '@/components/VInputSwitch/VInputSwitch.vue';
import VDropdown from '@/components/VDropdown/VDropdown.vue';
import CityAutocomplete from '@/components/CityAutocomplete/CityAutocomplete.vue';
import { FloatLabel } from '@sharedComponents';
import { provincesService, Province } from '@services/provinces.service';

export default defineComponent({
  name: 'CustomerAppData',

  props: ['customer', 'customerId', 'isLoading', 'user'],

  components: {
    CityAutocomplete,
    FloatLabel,
    VDropdown,
    VInputSwitch,
    VInputText,
  },

  setup(props, { emit }) {
    // Province dropdown
    const provinces = ref<{ label: string; value: string }[]>([]);

    onMounted(async () => {
      try {
        const data = await provincesService.getAll();
        provinces.value = data.map((p: Province) => ({
          label: p.name,
          value: p.code,
        }));
      } catch (error) {
        console.error('Errore nel caricamento delle province:', error);
      }
    });

    // City autocomplete
    const { value: business_city_id } = useField<number>('business_city_id');
    const {
      value: business_city_name,
      meta: business_city_meta,
      errors: business_city_errors,
      setTouched: business_city_setTouched,
    } = useField<string>('business_city_name');

    const businessCity = computed({
      get() {
        return business_city_id.value && business_city_name.value
          ? ({
              id: business_city_id.value,
              name: business_city_name.value,
            } as any)
          : business_city_name.value;
      },
      set(value: any | string) {
        if (value) {
          business_city_setTouched(true);
        }
        if (typeof value === 'string') {
          business_city_name.value = value;
        } else {
          business_city_id.value = value?.id;
          business_city_name.value = value?.name;
        }
      },
    });

    // Password fields
    const { value: pwd, errors: pwdErrors } = useField<string>('password', (value) => {
      if (!value || value.length === 0) return true;
      if (value.length < 6) return 'validation.min_length';
      return true;
    });
    const pwdTouched = useIsFieldTouched('password');

    const { value: cpwd, errors: cpwdErrors } = useField<string>('confirmPassword', (value) => {
      if (!pwd.value || pwd.value.length === 0) return true;
      if (!value) return 'validation.required';
      if (value !== pwd.value) return 'validation.password_mismatch';
      return true;
    });
    const cpwdTouched = useIsFieldTouched('confirmPassword');

    function onSubmit(...args: any[]) {
      emit('form-submit', ...args);
    }

    return {
      provinces,

      businessCity,
      business_city_meta,
      business_city_errors,

      pwd,
      pwdErrors,
      pwdTouched,
      cpwd,
      cpwdErrors,
      cpwdTouched,

      onSubmit,
    };
  },
});
